import React, { useState, useEffect } from 'react';
import { Chart } from 'primereact/chart';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import './chart.css';

export default function ChartJs({
  label,
  leads,
  replies,
  oppertunities,
  preApps,
  shoppers,
  outboundCalls,
  chartAppLeads,
  chartOpenApps,
  chartClosedApps,
  loading,
}) {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  useEffect(() => {
    // Force white text colors (ignore theme variables)
    const data = {
      labels: label,
      datasets: [
        {
          label: 'Leads',
          backgroundColor: 'rgb(15, 45, 62)',
          borderColor: 'rgb(15, 45, 62)',
          data: leads,
        },
        {
          label: 'Replies',
          backgroundColor: '#da474e',
          borderColor: '#da474e',
          data: replies,
        },
        {
          label: 'Outbound Calls',
          backgroundColor: '#D3D3D3',
          borderColor: '#D3D3D3',
          data: outboundCalls,
        },
        {
          label: 'App Count',
          backgroundColor: '#898fd3',
          borderColor: '#898fd3',
          data: chartAppLeads,
        },
        {
          label: 'Total Docs In',
          backgroundColor: '#777b92',
          borderColor: '#777b92',
          data: oppertunities,
        },
        {
          label: 'Pre Approvals',
          backgroundColor: '#eeabae',
          borderColor: '#eeabae',
          data: preApps,
        },
        {
          label: 'Shoppers',
          backgroundColor: '#86acd1',
          borderColor: '#86acd1',
          data: shoppers,
        },
        {
          label: 'Open',
          backgroundColor: '#95d186',
          borderColor: '#95d186',
          data: chartOpenApps,
        },
        {
          label: 'Closed',
          backgroundColor: '#f5ce42',
          borderColor: '#f5ce42',
          data: chartClosedApps,
        },
      ],
    };

    const options = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        datalabels: {
          display: true,
          anchor: 'end',
          align: 'end',
          color: '#ffffff', // White data labels
          font: {
            weight: 'bold',
            size: 15,
          },
        },
        legend: {
          labels: {
            color: '#ffffff', // White legend text
            font: {
              size: 12,
            },
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: '#ffffff', // White X-axis labels
            font: {
              weight: 500,
            },
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: '#ffffff', // White Y-axis labels
          },
          grid: {
            color: 'rgba(255, 255, 255, 0.1)', // Subtle white grid
            drawBorder: false,
          },
        },
      },
    };

    setChartData(data);
    setChartOptions(options);
  }, [label, leads, replies, oppertunities, preApps, outboundCalls, chartAppLeads]);

  return (
    <div
      style={{
        background: 'black',
        padding: '1rem',
        borderRadius: '8px',
        position: 'relative',
      }}
      className="card"
    >
      {loading && (
        <div
          className="chart-overlay"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10,
            borderRadius: '8px',
          }}
        >
          <i className="pi pi-spin pi-spinner" style={{ fontSize: '2.5rem', color: '#ffffff' }}></i>
        </div>
      )}

      <Chart type="bar" data={chartData} options={chartOptions} plugins={[ChartDataLabels]} />
    </div>
  );
}